import React from "react";
import { Card, Text, Flex, Stack } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { EmptyMessage } from "@components/shared";

export default function NoteList({ reqData = {} }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["notes", JSON.stringify(reqData)],
    queryFn: () => axios.post("/retrieve-notes/", reqData),
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const notes = data.data.response;

  return (
    <div>
      {notes.length > 0 ? (
        <Stack gap="sm">
          {notes.map((note) => (
            <Card key={note.id}>
              <Stack gap={2}>
                <Text fw={700}>{note.subject}</Text>
                <Text>{note.message}</Text>
                <Text size="sm" c="dimmed">
                  {[note.owned_by?.first_name, note.owned_by?.last_name]
                    .filter(Boolean)
                    .join(" ") || note.owned_by?.email || "—"}{" "}
                  - {new Date(note.created_at).toLocaleString()}
                </Text>
              </Stack>
            </Card>
          ))}
        </Stack>
      ) : (
        <EmptyMessage />
      )}
    </div>
  );
}
